import { Error } from "jquery";
import { baseURL } from "../../helper/helper";

export async function fetchFlashDealsProductsAPI() {
    const response = await fetch(`${baseURL}/api/version3/flash-deal`);
    if(!response.ok) throw new Error("Failed to retch flash deals products data");
    return response.json()
}